import * as React from "react";
import { Table } from "reactstrap";
import languages from "../../../data/languages";

class Languages extends React.Component {
  constructor(props) {
    super(props);

    this.createTableRow = this.createTableRow.bind(this);
  }

  createTableRow = (item) => {
    return (
      <tr key={item.id}>
        <th scope="row">{item.name}</th>
        <td className={item.read ? "checked" : ""}></td>
        <td className={item.write ? "checked" : ""}></td>
        <td className={item.speak ? "checked" : ""}></td>
      </tr>
    );
  };

  render() {
    return (
      <div className="languages">
        <div className="languages-title">Languages</div>
        <div className="languages-table">
          <Table>
            <thead>
              <tr>
                <th></th>
                <th>Read</th>
                <th>Write</th>
                <th>Speak</th>
              </tr>
            </thead>
            <tbody>{languages.map(this.createTableRow)}</tbody>
          </Table>
        </div>
      </div>
    );
  }
}

export default Languages;
